<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1 v-if="form.id">{{ $t('users.edit_user') }} </h1>
      <h1 v-else>{{ $t('users.new_user') }} </h1>
    </div>

    <div class="details-component__content content">

      <form class="form fixed-form">

        <table class="details-table tenant no-col-padding edit-table fixed-table label-col-wide-150">
          <tr v-if="isSuperAdmin()" class="details-table__row" :class="{'details-table__row_error' : errors.has('landlord')}">
            <td class="details-table__col details-table__col_label">
              <label for="landlord" class="form__label">{{ $t('common.landlord')}}</label>
            </td>
            <td class="details-table__col landlord__name" v-if="form.id === undefined">
            <el-select
                name="landlord"
                v-model="landlord"
                v-validate="'validLandlord'"
                :data-vv-as="$t('common.landlord')"
                v-if="landlords.items"
                :placeholder="$t('common.landlord')"
                @change="onLandlordChange(landlord)"
              >
                <el-option
                  v-for="landlord in landlords.items"
                  :key="landlord.id"
                  :label="landlord.name"
                  :value="landlord.id"
                ></el-option>
              </el-select>
              <span v-else-if="landlord">{{ landlord.name }}</span>
              <tooltip v-show="errors.has('landlord')" class="form__validation">{{ $t('errors.landlord_field_required') }}</tooltip>
            </td>
            <td class="details-table__col landlord__name disabled" v-if="form.id !== undefined">
              {{form.partner[0].landlord.name}}
            </td>
          </tr>

          <tr class="details-table__row" v-if="isLandlord()" :class="{'details-table__row_error' : errors.has('tenant')}">
            <td class="details-table__col details-table__col_label">
              <label for="tenant" class="form__label">{{ $t('common.tenant') }}</label>
            </td>
            <td class="details-table__col">
              <el-select name="tenant"
                  v-model="tenant"
                  filterable
                  v-validate="'validTenant'"
                  :data-vv-as="$t('common.tenant')"
                  v-if="tenants.data"
                  :placeholder="$t('common.tenant')">
                <el-option
                  v-for="tenant in tenants.data"
                  :key="tenant.id"
                  :label="tenant.name"
                  :value="tenant.id">
                </el-option>
              </el-select>
              <span v-else-if="selectedUser.partner">{{ selectedUser.partner.name }}</span>
              <tooltip v-show="errors.has('tenant')" class="form__validation">{{ $t('errors.tenant_field_required') }}</tooltip>
            </td>
          </tr>

          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('name')}">
            <td class="details-table__col details-table__col_label">
              <label for="name" class="form__label">{{ $t('common.name') }}</label>
            </td>
            <td class="details-table__col user__name">
              <input :placeholder="$t('common.name')" type="text" class="form__input" name="name" id="name" v-model="form.name" v-validate="'required|max:255'" :data-vv-as="$t('common.name')" data-vv-delay="1000"  />
              <tooltip v-show="errors.has('name')" class="form__validation">{{ $t('errors.name_field') }}</tooltip>
            </td>
          </tr>

          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('mobile')}">
            <td class="details-table__col details-table__col_label">
              <label for="mobile" class="form__label">{{ $t('common.phone') }}</label>
            </td>
            <td class="details-table__col">
              <input :placeholder="$t('common.phone')" type="text" class="form__input" name="mobile" id="mobile" value="" v-model.trim="form.mobile" v-validate="'validMobile'" :data-vv-as="$t('common.phone')" data-vv-delay="1000"  />
              <tooltip v-show="errors.has('mobile')" class="form__validation">{{ $t('errors.phone_field') }}</tooltip>
            </td>
          </tr>

          <tr class="details-table__row" :class="{'details-table__row_error' : errors.has('email')}" v-if="!form.managed_by_tenant">
            <td class="details-table__col details-table__col_label">
              <label for="email" class="form__label">{{ $t('common.email') }}</label>
            </td>
            <td class="details-table__col">
              <input
                :placeholder="$t('common.email')"
                type="email" class="form__input"
                name="email"
                id="email"
                value=""
                v-model="form.email"
                v-validate="'required|email|max:255'"
                :data-vv-as="$t('common.email')"
                data-vv-delay="2000"
                :disabled="!selectedUser.isRequiredEmailEdit && !isNew"
              />
              <tooltip v-show="errors.has('email')" class="form__validation">{{ $t('errors.email_field') }}</tooltip>
            </td>
          </tr>

          <tr class="details-table__row">
            <td class="details-table__col details-table__col_label">
              <label class="form__label">{{ $t('common.created_at')}}</label>
            </td>
            <td class="details-table__col">{{ form.created_at }}</td>
          </tr>

          <tr class="details-table__row auto-height">
            <td colspan="3" class="details-table__col txt-to-left padding-t-4">
              <label class="form__label form__label__long no-hide with_checkbox">
                <input v-model="form.managed_by_tenant" type="checkbox" id="can_use_cards" name="can_use_cards" class="form__fieldset__checkbox" >
                <span class="form__fieldset__custom-checkbox"></span>
                <span class="custom-checkbox-label">{{ $t('add_tenant.managed_by_tenant') }}</span>
              </label>
            </td>
          </tr>
        </table>
        <div class="form__buttons buttonset">
          <router-link v-if="isNew" :to="{ name: 'users' }" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <router-link v-else :to="{ name: 'user', params: { id: $route.params.id} }" class="buttonset__button btn btn--secondary">
            {{ $t('common.discard') }}
          </router-link>
          <button type="submit" :disabled="isButtonDisabled" :class="[{'btn--disabled' : isButtonDisabled }, 'buttonset__button btn btn--main']" @click.prevent.stop="onSubmit()">
          {{ $t('common.save') }}</button>
        </div>
      </form>
    </div>

    <WarningModal v-if="showWarningModal" @close="closeWarningModal">
      <h1 slot="header">{{ userWarningHeader }}</h1>
      <p slot="body">{{ userWarningBody }}</p>
    </WarningModal>

  </div>
</template>

<script>
import { parse, format, isValidNumber } from 'libphonenumber-js';
import { mapGetters } from 'vuex';
import * as mTypes from 'store/mutation-types';
import moment from 'moment';
import Tooltip from 'common/Tooltip';
import Autocomplete from 'common/Autocomplete';
import ConfirmationModal from 'common/ConfirmationModal';
import WarningModal from 'common/WarningModal';

export default {
  components: {
    Tooltip,
    Autocomplete,
    ConfirmationModal,
    WarningModal,
  },
  data() {
    return {
      form: {},
      landlord: null,
      tenant: null,
      showConfirmationModal: false,
      showWarningModal: false,
      userWarningBody: null,
      userWarningHeader: null,
      vehicles: null,
      removedVehicles: [],
      addWithPermit: false,
      isDisabledEmail: false,
      isButtonDisabled: false,
    };
  },
  mounted() {
    this.checkView();
  },
  computed: {
    isNew() {
      return !this.$route.params.id;
    },
    hasVehicles() {
      return this.vehicles && this.vehicles.length > 0;
    },
    ...mapGetters({
      landlords: 'landlord/landlords/landlords',
      selectedUser: 'users/user/user',
      userError: 'users/user/error',
      usersLimit: 'landlord/users/limit',
      usersKeywordFilter: 'landlord/users/keywordFilter',
      user: 'user/user/user',
      tenants: 'landlord/tenants/tenants',
      vehicleError: 'users/vehicles/error',
    }),
  },
  watch: {
    $route: 'checkView',
  },
  created() {
    this.$store.commit(`users/user/${mTypes.CLEAR_STATE}`);
    this.resetValidators();
    this.createValidators();
  },
  methods: {
    checkView() {
      this.fetchAllData();
      if (!this.$route.params.id) {
        this.$store.commit(`users/user/${mTypes.CLEAR_STATE}`);
        this.form = {};
        this.landlord = this.user.data.selectedRole.id;
        this.tenant = null;
        this.form.created_at = moment(new Date()).format('DD.MM.YYYY');
        if (this.isSuperAdmin() && this.$route.query.landlord) {
          this.landlord = parseInt(this.$route.query.landlord, 10);
        }
        if (this.isLandlord() && this.$route.query.tenant) {
          this.tenant = parseInt(this.$route.query.tenant, 10);
        }
      }
    },
    trimVehicleReg() {
      if (this.form.vehicleReg) {
        this.form.vehicleReg = this.form.vehicleReg.replace('-', '').replace(' ', '');
      }
    },
    stopInputAtDashAndSpace(event) {
      if (event.key === '-' || event.key === ' ') {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    fetchAllData() {
      if (this.$route.params.id) {
        this.fetchUser();
      }
      if (this.isLandlord()) {
        this.fetchTenants();
      }
      if (this.isSuperAdmin()) {
        this.fetchLandlords();
      }
    },
    fetchUser() {
      this.$store.dispatch('users/user/fetch', { id: this.$route.params.id, user: this.user }).then(() => {
        this.form = this.selectedUser;

        if (this.selectedUser.partner) {
          this.tenant = this.selectedUser.partner[0].id;
          this.landlord = this.selectedUser.partner[0].landlord.id;
        }
        if (this.selectedUser.vehicles) {
          this.vehicles = this.selectedUser.vehicles;
        }
        this.formatMobileNrForForm();

        this.checkDisabledEmail();
      });
    },

    onLandlordChange() {
      if (this.landlord) {
        this.fetchTenants(this.landlord);

      }
    },

    fetchLandlords() {
      if (this.user.data) {
        // Fetch landlords
        this.$store.dispatch('landlord/landlords/list', { user: this.user })
      }
    },

    fetchTenants(landlordId) {
      if (this.user.data.selectedRole.isSuperadmin && landlordId) {
        this.$store.dispatch('landlord/tenants/autocomplete', {landlordId: landlordId, user: this.user});
      } else {
        this.$store.dispatch('landlord/tenants/autocomplete', {landlordId: [this.user.data.selectedRole.id], user: this.user});
      }
    },

    formatMobileNrForForm() {
      if (this.form.mobile) {
        this.form.mobile = format({ country: this.form.mobileCountry, phone: this.form.mobile.toString() }, 'International_plaintext');
      } else {
        this.form.mobile = '';
      }
    },
    onSubmit() {
      this.$store.commit(`users/vehicles/${mTypes.DATA_ERROR}`, null);
      let data = null;

      if (this.form.managed_by_tenant) {
        data = {
          name: this.form.name,
          mobile: this.form.mobile,
          email: '',
          tenant: 'validTenant',
        };

        this.form.email = '';
      } else {
        data = {
          name: this.form.name,
          mobile: this.form.mobile,
          email: this.form.email,
          tenant: 'validTenant',
        };
      }

      this.$validator.validateAll(data)

        .then((success) => {
          this.$store.commit(`users/user/${mTypes.DATA_ERROR}`, null);
          this.deleteVehicles();
          if (success) {
            this.isButtonDisabled = true;
            this.setCreatedBy();
            this.form.partner_id = this.isLandlord() ? this.tenant : this.user.data.selectedRole.id;
            this.parsePhoneBeforeSave();
            this.$store.dispatch('users/user/saveUser', { selectedUser: this.form, user: this.user })
              .then(() => {
                if (this.userError) {
                  this.userWarningHeader = this.$t('common.warning');
                  this.userWarningBody = this.$t('users.save_error_email');
                  this.showWarningModal = true;
                } else if (this.vehicleError) {
                  this.showWarningModal = true;
                  this.userWarningHeader = this.$t('common.warning');
                  this.userWarningBody = this.$t(`errors.${this.vehicleError.body.error}`);
                  this.vehicles = this.selectedUser.vehicles;
                  this.removedVehicles = [];
                } else {
                  this.resetValidators();
                  this.$store.dispatch('landlord/users/fetch', { user: this.user, limit: this.usersLimit, keyword: this.usersKeywordFilter });
                  if (this.addWithPermit) {
                    this.$router.push({ name: 'add-permit-to-user', params: { userId: this.selectedUser.id } });
                  } else {
                    this.$router.push({ name: 'user', params: { id: this.selectedUser.id } });
                  }
                }
                this.isButtonDisabled = false;
              })
              .catch(() => {
                this.$store.commit(`users/user/${mTypes.DATA_ERROR}`, true);
              });
          } else {
            this.$store.commit(`users/user/${mTypes.DATA_ERROR}`, true);
          }
        })
        .catch(() => {
          this.$store.commit(`users/user/${mTypes.DATA_ERROR}`, true);
        });
    },
    setCreatedBy() {
      this.form.created_by = this.user.data.selectedRole.id;
    },
    parsePhoneBeforeSave() {
      const parsedPhone = parse(this.form.mobile, { country: { default: 'EE' } });
      this.form.mobileCountry = parsedPhone.country;
      this.form.mobile = parsedPhone.phone;
    },
    resetValidators() {
      this.$validator.remove('validMobile');
      this.$validator.remove('validTenant');
      this.$validator.clean();
    },
    closeWarningModal() {
      this.showWarningModal = false;
    },
    createValidators() {
      this.createPhoneNrValidator();
      this.createTenantValidator();
      this.createLandlordValidator();
    },
    createPhoneNrValidator() {
      this.$validator.extend('validMobile', {
        getMessage: () => 'Please insert valid phone number. Mobile number must include country code.',
        validate: (value) => {
          if (value.trim === '') {
            return true;
          }
          const parsed = parse(value, { country: { default: 'EE' } });
          return isValidNumber(parsed);
        },
      });
    },
    createTenantValidator() {
      this.$validator.extend('validTenant', {
        getMessage: () => 'Tenant must be selected',
        validate: () => this.isLandlord() && (typeof this.tenant !== 'undefined' && this.tenant !== null),
      });
    },
    createLandlordValidator() {
      this.$validator.extend('validLandlord', {
        getMessage: () => 'Tenant must be selected',
        validate: () => this.isSuperAdmin() && (typeof this.landlord !== 'undefined' && this.landlord !== null),
      });
    },
    removeVehicle(vehicle) {
      if (this.form.vehicle && this.form.vehicle.id === vehicle.id) {
        this.form.vehicle = null;
      }
      const index = this.vehicles.findIndex(obj => obj === vehicle);
      this.$delete(this.vehicles, index);
      this.removedVehicles.push(vehicle.id);
    },
    deleteVehicles() {
      this.removedVehicles.forEach((el) => {
        this.$store.dispatch('users/vehicles/delete', { id: el, user: this.user });
      });
    },

    checkDisabledEmail() {
      let isDiabled = false;

      if (this.$route.name === 'edit-user') {
        isDiabled = true;
      }

      if (!this.form.email) {
        isDiabled = false;
      }

      this.isDisabledEmail = isDiabled;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/blocks/details.scss';

.user__name input {
  font-family: 'Geogrotesque Md', sans-serif !important;
}

.form {

  &__selectbox {
    width: 200px;
  }

  .add-vehicle {
    width: 100%;
    font-size: 12px;

    ::placeholder {
      font-size: 12px;
      padding: 15px 0 0 0;
      opacity: 0.4;
      padding: 10px 0;
      font-weight: 700;
    }

    &--btn-plus {
      float: right;
      position: relative;
      bottom: 26px;
      border: none;
      background: none;
      font-size: 17px;
      right: 4px;
      color: var(--brand-blue);
      cursor: pointer;
    }
  }

  .el-select {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/users/AddEditUserView.vue